export const PROPERTY_FEATURES = {
  WI_FI: 'wi-fi',
  CENTRAL_HEATING: 'central-heating',
  DISHWASHER: 'dishwasher',
  WASHING_MACHINE: 'washing-machine',
  MICROWAVE: 'microwave',
  OVEN: 'oven',
  CABLE_TV: 'cable-tv',
  AIR_CONDITIONING: 'air-conditioning',
  OUTDOOR_AREA: 'outdoor-area',
  ELEVATOR: 'elevator',
  ACCESSIBILITY: 'accessibility',
  UNFURNISHED: 'unfurnished'
};
